<template>
  <div>
    <div
      v-if="isAdmin && isPromoteur"
      v-scroll-to="'#commentSection'"
      class="has-background-primary is-margin-bottom-small is-fullwidth is-flex-between has-text-white is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small has-cursor-pointer">
      <div class="has-text-weight-semibold is-flex-center">
        <div
          class="is-flex-center comment-icon">
          <span
            v-if="program.comments && program.comments.length"
            :style="`border-color: #24323B`"
            class="orange-bullet"></span>
          <span
            class="icon is-size-3 icon-margin">
            <i class="fas fa-sticky-note"></i>
          </span>
        </div>
        <span class="is-margin-left-xsmall">{{ program.comments.length > 1 ? 'Commentaires' : 'Commentaire' }}</span>
        <span class="is-margin-left-xxsmall">({{ program.comments.length }})</span>
      </div>
      <div class="is-underline is-size-6 is-margin-right">
        <i>Ajouter un commentaire</i>
      </div>
    </div>
    <div
      v-if="(documents && documents.length) || (checkedDocuments && checkedDocuments.length)"
      class="has-background-white is-margin-bottom-small">
      <div class="columns is-vcentered is-gapless is-border-bottom has-background-light is-marginless">
        <div
          v-if="documents && documents.length"
          class="column is-padding-top-small is-padding-bottom-small is-padding-left">
          <b>{{ documents.length }} document<span v-if="documents.length > 1">s</span></b>
          <router-link
            :to="{ name: 'ProgramEdit', params: { id: program.pk }, query: { panel: 'DOCS' } }"
            class="is-linkTextPicto is-size-6 is-padding-left is-padding-right-xxsmall">
            <span class="is-italic">Modifier liste des documents</span>
            <span class="icon"><i class="fal fa-long-arrow-right"></i></span>
          </router-link>
        </div>
        <div class="column is-narrow">
          <div
            class="page-header-btn is-success is-small is-padding-left-small is-padding-right-small"
            v-if="checkedDocuments && checkedDocuments.length === 1">
            <span class="icon is-padding-right-xsmall">
              <i
                class="fas"
                :class="loadingDownloadDoc ? 'fa-spinner fa-spin' : 'fa-cloud-download-alt'"></i>
            </span>
            <span
              @click="downloadDocument(checkedDocuments[0])"
              class="has-text-weight-medium">Télécharger document</span>
          </div>
          <a
            v-if="checkedDocuments && checkedDocuments.length > 1"
            class="page-header-btn is-success is-small is-padding-left-small is-padding-right-small"
            @click="downloadDocuments">
            <span class="icon is-padding-right-xsmall">
              <i
                class="fas"
                :class="loadingDownloadDoc ? 'fa-spinner fa-spin' : 'fa-cloud-download-alt'"></i>
            </span>
            <span class="has-text-weight-medium">Télécharger documents</span>
          </a>
        </div>
      </div>
      <div>
        <div
          v-for="(document, index) in documents"
          :key="'tr' + index"
          class="columns is-vcentered is-gapless is-marginless is-padding-right is-padding-left is-padding-top-xxsmall is-padding-bottom-xxsmall is-minH50p"
          :class="{'is-border-top': index > 0}"
          :id="document.cloudinary_id">
          <div class="column is-narrow is-size-6 is-margin-right-xxsmall">
            <span class="icon is-small"><i class="fal fa-file-pdf"></i></span>
          </div>
          <div class="column is-size-6">
            <a
              target="_blank"
              :href="document.path"
              :download="document.filename">{{ document.filename }}</a>
          </div>
          <div class="column is-narrow">
            <div class="dropdown is-hoverable is-right">
              <div class="dropdown-trigger">
                <button
                  class="button is-xsmall is-circle "
                  @click="selectDocument(document)"
                  :class="[{'is-dark is-outlined':!isChecked(document), 'is-success':isChecked(document)}]">
                  <span
                    v-if="!isChecked(document)"
                    class="icon is-small"><i class="fas fa-download"></i></span>
                  <span
                    v-else
                    class="icon is-small"><i class="far fa-lg fa-check"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="has-background-white is-padding-bottom-xsmall is-margin-bottom-small"
      v-if="(program.pictures && program.pictures.length) || (program.descriptions && program.descriptions.length)">
      <div
        class="is-padding-top"
        v-if="program.pictures && program.pictures.length > 0">
        <div class="is-relative">
          <swiper
            ref="awesomeSwiper"
            :options="swiperOption"
            class="swiper-container-pagination-top"
            :class="{'swiper-slide-to-clicked-slide': swiperOption.slideToClickedSlide}"
            id="mySwiper"
            @slideChange="slideChange">
            <div
              class="swiper-pagination swiper-pagination-bullet--dashed"
              slot="pagination"
              v-if="program.pictures && program.pictures.length > 1"></div>
            <swiper-slide
              v-for="(picture, idx) in program.pictures"
              :key="idx">
              <img :src="picture.cloudinary_id | cloudinary({aspect_ratio: '16:9', crop: 'fill', quality: 70})">
            </swiper-slide>
          </swiper>
        </div>
        <div
          class="field is-grouped swiper-btns-video has-background-light"
          v-if="program.videos && program.videos.length > 0">
          <div
            v-for="(v, idx) in program.videos"
            :key="idx"
            class="control">
            <button
              v-if="idx >= 0"
              class="button has-background-light is-radiusless"
              @click="toggleVideo(v)">
              <div class="has-background-primary has-text-white is-padding-left-xxsmall is-padding-right-xxsmall is-margin-right-xxsmall">
                <span class="is-size-6"><i class="fas fa-video fa-lg"></i></span>
              </div>
              <span class="is-size-6 is-transform-none">Vidéo de présentation ({{ (idx + 1) }})</span>
            </button>
          </div>
        </div>
      </div>
      <div class="is-margin-top-xsmall is-margin-bottom is-padding-left">
        <router-link
          :to="{ name: 'ProgramEdit', params: { id: program.pk }, query: { panel: 'FICHE_PROGRAMME' } }"
          class="is-linkTextPicto is-size-6">
          <span class="is-italic">
            Modifier diaporama d’image
          </span>
          <span class="icon"><i class="far fa-arrow-right"></i></span>
        </router-link>
      </div>
      <template v-if="program.descriptions && program.descriptions.length">
        <div
          class="columns is-centered is-margin-top is-margin-bottom is-gapless"
          v-for="(description, index) in program.descriptions"
          :key="index">
          <div class="column content ql-editor is-padding-right is-padding-left">
            <h2><strong>{{ description.title }}</strong></h2>
            <p v-html="description.text"></p>
          </div>
        </div>
      </template>
      <div
        class="columns is-centered is-margin-top is-margin-bottom is-gapless"
        v-else>
        <div class="column content is-9">
          <p>Aucune description.</p>
        </div>
      </div>
    </div>
    <div id="mapVue">
      <program-map
        class="is-margin-bottom-xlarge"
        ref="map"
        :source="program"></program-map>
    </div>
    <div
      v-if="isAdmin && isPromoteur"
      class="has-background-white-bis is-padding">
      <div
        v-if="program.comments && program.comments.length"
        class="has-background-white-bis">
        <div class="row-width-actions-bar columns is-gapless is-marginless">
          <div class="column is-self-centered is-padding-top-xxsmall is-padding-bottom-xxsmall has-background-white-bis">
            <span class="title is-6">
              <span class="is-uppercase is-margin-right-xsmall">{{ program.comments.length > 1 ? 'Commentaires' : 'Commentaire' }}</span>
              <i class="is-size-7 has-text-weight-normal">(Visible uniquement par les administrateurs de votre société)</i>
            </span>
          </div>
        </div>
        <div
          v-for="(comment, index) in program.comments"
          :key="index"
          class="is-margin-top-large is-margin-bottom-large has-background-white-bis">
          <div
            v-if="openedComment === index"
            class="is-border-top columns is-gapless">
            <div class="column">
              <wysiwyg-editor
                :light="true"
                :tooltip-top="true"
                :model="comment.text"
                @change="val => comment.text = val"
                class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
              </wysiwyg-editor>
            </div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div>
                <button
                  @click="comment.date = moment().format(); patchProgramComment('modifié'); baseProgramComment = null; openedComment = null"
                  type="button"
                  class="button"
                  :class="[(baseProgramComment !== comment) ? 'is-success' : 'is-info']"
                  :disabled="!comment.text || (baseProgramComment === comment.text) || loadProgramComment">
                  <span class="icon is-small">
                    <i
                      v-if="loadProgramComment"
                      class="fas fa-spinner fa-spin"></i>
                    <i
                      v-else
                      class="fal fa-save"></i>
                  </span>
                </button>
              </div>
              <div class="">
                <button
                  :disabled="!baseProgramComment"
                  type="button"
                  :class="{'actionsOnRow-btn--hoverIsDanger': comment}"
                  @click="openedComment = null; comment.text = baseProgramComment; baseProgramComment = null">
                  <span class="icon is-small"><i class="fal fa-times"></i></span>
                </button>
              </div>
            </div>
          </div>
          <div
            v-else
            @click="openWysiwyg(index)"
            :class="currentUser.pk === comment.user_pk && openedComment === null ? 'has-cursor-pointer' : ''"
            class="vadDiscussion is-border-top">
            <div
              class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
              <div
                class="content"
                v-html="comment.text"></div>
            </div>
          </div>
          <div class="is-flex-between is-margin-top-xxsmall has-background-white-bis">
            <div>
              <span class="is-size-6 has-text-weight-semibold is-margin-right-small">Date : <span class="has-text-weight-normal">{{ comment.date | prettyDatetime }}</span></span>
              <span class="is-size-6 has-text-weight-semibold">Auteur : <span class="has-text-weight-normal">{{ comment.user_first_name }} {{ comment.user_last_name }}</span></span>
            </div>
            <div>
              <span
                @click="openWysiwyg(index)"
                v-if="currentUser.pk === comment.user_pk && openedComment === null"
                class="is-size-6 is-underline is-margin-right-small has-cursor-pointer"><i>Modifier</i></span>
              <span
                @click="deleteProgramComment(index)"
                v-if="(currentUser.pk === comment.user_pk || isAdmin) && openedComment === null"
                class="is-size-6 is-underline has-cursor-pointer"><i>Supprimer</i></span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="has-background-white">
        <div class="row-width-actions-bar columns is-gapless is-marginless">
          <div class="column has-background-white-bis is-self-centered is-padding-top-xsmall is-padding-bottom-xsmall">
            <span class="is-uppercase title is-6">Ajouter commentaire</span>
            <i
              v-if="program.comments && !program.comments.length"
              class="is-size-7 has-text-weight-normal is-padding-left-xsmall">(Visible uniquement par les administrateurs de votre société)</i>
          </div>
          <div class="column is-narrow">
          </div>
        </div>
        <template>
          <div
            class="is-border-top columns is-gapless">
            <div class="column">
              <wysiwyg-editor
                ref="commentSection"
                id="commentSection"
                :light="true"
                :tooltip-top="true"
                :model="programComment"
                @change="val => programComment = val"
                class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
              </wysiwyg-editor>
            </div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div>
                <button
                  @click="addProgramComment()"
                  type="button"
                  class="button"
                  :class="[(baseProgramComment !== programComment) ? 'is-success' : 'is-info']"
                  :disabled="!programComment || loadProgramComment">
                  <span class="icon is-small">
                    <i
                      v-if="loadProgramComment"
                      class="fas fa-spinner fa-spin"></i>
                    <i
                      v-else
                      class="fal fa-save"></i>
                  </span>
                </button>
              </div>
              <div class="">
                <button
                  :disabled="!programComment"
                  type="button"
                  :class="{'actionsOnRow-btn--hoverIsDanger': programComment}"
                  @click="programComment = null">
                  <span class="icon is-small"><i class="fal fa-times"></i></span>
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Ajv from 'ajv'
import Vue from 'vue'

Vue.prototype.moment = moment
export default {
  name: 'ProgramPromoteurInfos',
  components: {
    swiperSlide,
    swiper,
    ProgramMap: () => import('../ProgramMap')
  },
  props: {
    program: {
      required: true
    }
  },
  data () {
    return {
      checkedDocuments: [],
      loadingDownloadDoc: false,
      programComment: null,
      baseProgramComment: null,
      loadProgramComment: false,
      openedComment: null
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isPromoteur']),
    ...mapState(['currentUser']),
    documents () {
      return this.program.documents.filter(x => x.destination && x.destination.includes('program'))
    },
    swiper () {
      return this.$refs.awesomeSwiper.swiper
    },
    swiperOption () {
      // autoHeight: false,
      let options = {
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 1.10,
        centeredSlides: true,
        slideToClickedSlide: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      }
      return options
    }
  },
  mounted () {
    setTimeout(() => {
      this.setViewToTop()
    }, 150)
  },
  methods: {
    openWysiwyg (index) {
      if (this.openedComment === null && this.currentUser.pk === this.program.comments[index].user_pk) {
        this.openedComment = index
        this.baseProgramComment = this.program.comments[index].text
      }
    },
    addProgramComment () {
      if (this.programComment) {
        this.program.comments.push({
          user_pk: this.currentUser.pk,
          user_first_name: this.currentUser.first_name,
          user_last_name: this.currentUser.last_name,
          text: this.programComment,
          date: moment().format()
        })
        this.programComment = null
        this.patchProgramComment()
      } else {
        this.$toasted.global.danger('Veuillez renseigner un commentaire')
      }
    },
    async deleteProgramComment (i) {
      let value = await this.$swal({
        title: 'Suppression commentaire',
        text: 'Confirmer la suppression du commentaire',
        icon: 'warning',
        confirmButtonText: 'Supprimer',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value && value.dismiss) return false
      else if (value.value && i >= 0) {
        this.program.comments.splice(i, 1)
        this.patchProgramComment('supprimé')
      }
    },
    async patchProgramComment (type = 'ajouté') {
      this.loadProgramComment = true
      try {
        const schema = {
          type: 'object',
          properties: {
            user_pk: { type: 'string' },
            user_first_name: { type: 'string' },
            user_last_name: { type: 'string' },
            text: { type: 'string' },
            date: { type: 'string' }
          },
          required: ['user_pk', 'user_first_name', 'user_last_name', 'text', 'date'],
          additionalProperties: false
        }
        const validate = new Ajv().compile(schema)
        for (let i = 0; i < this.program.comments.length; i++) {
          const el = this.program.comments[i]
          const valid = validate(el)
          if (!valid) {
            this.loadProgramComment = false
            return this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
          }
        }
        await this.$api.patch(this.$resources.PROGRAM, this.program.pk, { comments: this.program.comments })
        this.loadProgramComment = false
        this.$toasted.global.success(`Commentaire ${type}`)
      } catch (e) {
        console.log(e)
        this.loadProgramComment = false
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    setViewToTop () {
      this.$nextTick(function () {
        var container = document.querySelector('#app')
        if (container) {
          container.scrollTo(0, 0)
        }
      })
    },
    slideChange () {
      this.$nextTick(() => {
        let current = document.querySelector('.swiper-slide-active')
        this.currentSlide = current.id
      })
    },
    toggleVideo (v) {
      let params = { source: v }
      this.$store.commit('setModal', { mode: 'VIDEO_PREVIEW', params })
    },
    async downloadDocuments () {
      try {
        await this.$api.post(this.$resources.EXPORT_FILES, { sources: this.checkedDocuments, download_name: this.documentName })
        this.$toasted.global.success('Vous allez recevoir vos fichiers par mail')
        this.checkedDocuments = []
      } catch (e) {
        this.$toasted.global.danger('Erreur lors du téléchargement des fichiers.')
      }
    },
    isChecked (document) {
      return this.checkedDocuments.map(x => x.cloudinary_id).includes(document.cloudinary_id)
    },
    selectDocument (document) {
      let idx = this.checkedDocuments.findIndex(x => x.cloudinary_id === document.cloudinary_id)
      if (idx >= 0) {
        this.checkedDocuments.splice(idx, 1)
      } else {
        this.checkedDocuments.push(document)
      }
    },
    downloadDocument (file) {
      let link = document.createElement('a')
      const parts = file.filename.split('.')
      const cleanFilename = parts.slice(0, -1).join('.')
      parts.pop()
      link.href = file.path.replace(
        '/upload/',
        `/upload/fl_attachment:${encodeURIComponent(cleanFilename)}/`
      )
      link.download = file.filename
      link.click()
    }
  }
}
</script>

<style>
  .content p {
    margin-bottom: 0 !important;
  }
</style>
